import {
	Checkbox,
	createStyles,
	FormControlLabel,
	TextField,
	Theme,
	Typography,
	withStyles,
} from "@material-ui/core";
import AppContext from "../Context/Context";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import demoApplicationImg from "../assets/demoApplicationImg.png";
import thankYouImg from "../assets/thankYou.png";
import clsx from "clsx";
import { Form, Formik } from "formik";
import ErrorIcon from "../assets/icons/ErrorIcon";
import BriaButton, { BUTTONTYPES } from "./UI/BriaButton";
import BriaLogo from "../assets/icons/BriaLogo";
import React from "react";
import { getSendDemoApplicationEmail } from "../GraphQL/queries";
import Analytics, { ANALYTICS_EVENTS } from "../Models/Analytics";

interface IState {
	interests: Set<string>;
	demoApplicationSuccess: boolean;
	demoApplicationError: boolean;
	loading: boolean;
}

class DemoApplicationDialog extends React.Component<{}, IState> {
	state: IState = {
		interests: new Set<string>(),
		demoApplicationSuccess: false,
		demoApplicationError: false,
		loading: false,
	};

	render() {
		const { classes }: any = this.props;
		const interestsLabels = [
			"Brand styles",
			"Person modification",
			"Background modification",
			"Immediate upload",
			"Object removal",
			"Stills to video",
		];

		const handleCloseDemoApplicationDialog = (context: any) => {
			context.setDisplayDemoApplicationDialogState(false);
			this.setState({
				demoApplicationSuccess: false,
				demoApplicationError: false,
				interests: new Set<string>(),
			});
		};

		const initialValues = {
			demoApplicationText: "",
		};

		const handleCheckboxChange = (event: any, interest: string) => {
			if (event.target.checked) {
				const newInterests = this.state.interests;
				newInterests.add(interest);
				this.setState({
					interests: newInterests,
				});
			} else {
				const newInterests = this.state.interests;
				newInterests.delete(interest);
				this.setState({
					interests: newInterests,
				});
			}
		};

		const startLoading = () => this.setState({ loading: true });
		const stopLoading = () => this.setState({ loading: false });

		const handleSubmitSuccess = (res: any = {}) => {
			const { sendDemoApplicationEmail: isSent } = res;
			this.setState({
				demoApplicationError: !isSent,
				demoApplicationSuccess: isSent,
			});
			Analytics.logEvent(ANALYTICS_EVENTS.DEMO_APPLICATION_SUBMITTED, {
				succeeded: isSent,
			});
			stopLoading();
		};

		const handleSubmitFailure = () => {
			stopLoading();
		};

		const submitDemoApplication = async (values: any, context: any) => {
			startLoading();
			try {
				if (context.user) {
					getSendDemoApplicationEmail(
						context.user.uid,
						[...this.state.interests],
						values.demoApplicationText
					)
						.then(handleSubmitSuccess)
						.catch(handleSubmitFailure);
				}
			} catch (error: any) {
				stopLoading();
			}
		};

		const demoApplicationSucceeded = () => (
			<Box>
				<Box>
					<img src={thankYouImg} className={classes.mainImg}></img>
				</Box>
				<Box className={classes.content}>
					<Typography
						className={clsx(
							classes.boldText,
							classes.fontColor,
							classes.title
						)}
					>
						Thank you!
					</Typography>
					<Typography
						className={clsx(classes.fontColor, classes.description)}
					>
						We will be in touch shortly.
					</Typography>
					<Box className={classes.logoContainer}>
						<BriaLogo className={classes.logo} />
					</Box>
				</Box>
			</Box>
		);

		return (
			<AppContext.Consumer>
				{(context) => {
					return (
						<Dialog
							onClose={() => {
								handleCloseDemoApplicationDialog(context);
							}}
							open={context.displayDemoApplicationDialog}
							maxWidth={false}
							classes={{
								paper: classes.dialog,
							}}
						>
							<Box>
								{this.state.demoApplicationSuccess ? (
									demoApplicationSucceeded()
								) : (
									<Box>
										<Box>
											<img
												src={demoApplicationImg}
												className={classes.mainImg}
											></img>
										</Box>
										<Box className={classes.content}>
											<Typography
												className={clsx(
													classes.boldText,
													classes.fontColor,
													classes.title
												)}
											>
												Bria Pro
											</Typography>
											<Typography
												className={clsx(
													classes.fontColor,
													classes.description
												)}
											>
												Unleash your full creative
												potential.
											</Typography>
											<Typography
												className={clsx(
													classes.fontColor,
													classes.description
												)}
											>
												Complete this form and we’ll be
												in touch to arrange access to
												Bria Pro.
											</Typography>
											<Formik
												initialValues={initialValues}
												isInitialValid={false}
												onSubmit={(values) =>
													submitDemoApplication(
														values,
														context
													)
												}
											>
												{({
													values,
													errors,
													handleChange,
													isValid,
												}) => (
													<Form
														className={
															classes.demoApplicationForm
														}
													>
														<Box
															className={
																classes.interestsContainer
															}
														>
															<Typography
																className={clsx(
																	classes.fontColor,
																	classes.description
																)}
															>
																I’m interested
																in
															</Typography>
															<Box
																className={
																	classes.interests
																}
															>
																{interestsLabels.map(
																	(
																		interestLabel
																	) => (
																		<FormControlLabel
																			className={
																				classes.checkboxControl
																			}
																			control={
																				<Checkbox
																					className={
																						classes.checkbox
																					}
																					color="primary"
																					checked={this.state.interests.has(
																						interestLabel
																					)}
																				/>
																			}
																			onChange={(
																				e
																			) => {
																				handleCheckboxChange(
																					e,
																					interestLabel
																				);
																			}}
																			label={
																				interestLabel
																			}
																		/>
																	)
																)}
															</Box>
														</Box>
														<Typography
															className={clsx(
																classes.fontColor,
																classes.description,
																classes.feedbackLabel
															)}
														>
															Anything you’d like
															to tell us?
														</Typography>
														<TextField
															id="demoApplicationText"
															className={
																classes.demoApplicationText
															}
															multiline={true}
															rows={4}
															onChange={
																handleChange
															}
															value={
																values.demoApplicationText
															}
															error={
																!!errors.demoApplicationText
															}
															helperText={
																errors.demoApplicationText
															}
															fullWidth={true}
														/>
														{this.state
															.demoApplicationError && (
															<Typography
																className={
																	classes.error
																}
																color="secondary"
															>
																<ErrorIcon
																	className={
																		classes.errorIcon
																	}
																/>
																<span>
																	Ooops.
																	Please try
																	again later
																</span>
															</Typography>
														)}
														<Box
															className={
																classes.submitButton
															}
														>
															<BriaButton
																buttonType={
																	BUTTONTYPES.PRIMARY
																}
																type="submit"
																// disabled={this.state.loading || !isValid}
																disabled={
																	this.state
																		.loading
																}
															>
																Send
															</BriaButton>
														</Box>
													</Form>
												)}
											</Formik>
										</Box>
									</Box>
								)}
							</Box>
						</Dialog>
					);
				}}
			</AppContext.Consumer>
		);
	}
}
const styles = (theme: Theme) =>
	createStyles({
		dialog: {
			borderRadius: "10px !important",
			maxWidth: 618,
		},
		mainImg: {
			marginTop: 60,
		},
		boldText: {
			fontWeight: 700,
		},
		content: {
			padding: "30px 30px  60px 30px",
		},
		fontColor: {
			color: "#495057",
		},
		description: {
			fontSize: 14,
			marginBottom: 10,
		},
		feedbackLabel: {
			marginBottom: 5,
		},
		title: {
			fontSize: 24,
			marginBottom: 11,
		},
		error: {
			fontSize: 14,
			marginTop: 13,
			marginBottom: 2,
			"& span": {
				marginLeft: 5,
				color: "red",
			},
		},
		errorIcon: {
			fontSize: 14,
		},
		demoApplicationForm: {
			"& .MuiFormControl-root": {
				width: "100%",
			},
			"& .MuiFormHelperText-root.Mui-error": {
				color: "red",
			},
		},
		demoApplicationText: {
			"& textarea": {
				border: "1px solid #ddd",
				borderRadius: "5px",
				padding: "1rem",
			},
			"& .MuiInput-underline:before, .MuiInput-underline:after, .MuiInput-underline:hover":
				{
					borderBottom: "none !important",
				},
		},
		submitButton: {
			marginTop: 30,
			width: "100%",
			textAlign: "right",
			"& button": {
				padding: "7px 35px",
			},
		},
		logo: {
			width: 102,
			height: "100%",
		},
		logoContainer: {
			width: "100%",
			textAlign: "right",
		},
		interests: {
			display: "flex",
			flexWrap: "wrap",
			columnGap: 45,
			rowGap: 14,
		},
		interestsContainer: {
			display: "flex",
			marginBottom: 24,
			"& p": {
				minWidth: 114,
				marginRight: 20,
				marginBottom: 0,
			},
		},
		checkboxControl: {
			margin: 0,
			maxWidth: 100,
			alignItems: "center",
			display: "flex",
			"& span": {
				fontSize: 12,
				textAlign: "start",
			},
		},
		checkbox: {
			paddingTop: 0,
			paddingBottom: 0,
			paddingLeft: 0,
		},
	});

export default withStyles(styles)(DemoApplicationDialog);
